import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0e96eea7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "text-h5 font-weight-black" }
const _hoisted_3 = { class: "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    rounded: "lg",
    height: "600px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center py-6" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formName), 1)
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.questionLang1), 1)
          ]),
          _createVNode(_component_v_btn, {
            icon: "mdi-close",
            variant: "text",
            onClick: _ctx.closeModal,
            size: "x-large"
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "overflow-y-auto pt-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, {
            class: "pt-0",
            lines: "three"
          }, {
            default: _withCtx(() => [
              (_ctx.responsesByPage.length === 0)
                ? (_openBlock(), _createBlock(_component_v_list_item, {
                    key: 0,
                    class: "text-center"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('i18n.noResponsesText')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responsesByPage, (response, index) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  class: "pt-0",
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_subtitle, { class: "pb-2" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.formatDate(response.submission_date)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(response.value), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_pagination, {
        length: _ctx.totalPages,
        rounded: "circle",
        modelValue: _ctx.selectedPageNumber,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPageNumber) = $event)),
          _ctx.getPaginatedResponses
        ]
      }, null, 8, ["length", "modelValue", "onUpdate:modelValue"])
    ]),
    _: 1
  }))
}